/* eslint-disable jsx-a11y/label-has-associated-control */
import TableWrapper from 'components/common/table-wrapper/TableWrapper'
import { alertTypes, initialMetaForTable } from 'constants/Common'
import React, { useEffect, useState } from 'react'
import { PencilSimple, Trash } from 'phosphor-react'
import { getActionButtonProps } from 'utils/common'

import { toast } from 'react-toastify'
import CustomToast from 'components/common/custom-toast/CustomToast'
import {
  createTeam,
  deleteTeam,
  getTeams,
  updateTeam,
} from 'containers/Teams/Api'
import ConfirmationModal from './ConfirmationModal'
import TeamModal from './TeamsModal'

let timeout
const DEBOUNCE_DELAY = 700

function TeamsListing() {
  const [teamsList, setTeamsList] = React.useState([])
  const [loading, setLoading] = React.useState(true)
  const [meta, setMeta] = React.useState(initialMetaForTable)
  const [isTeamModalVisible, setTeamModalVisible] = React.useState(false)
  const [refresh, setRefresh] = React.useState(false)
  const [selectedTeam, setSelectedTeam] = useState()
  const [isTeamConfirmationModalVisible, setTeamConfirmationModalVisible] =
    useState(false)
  const [isDeleting, setIsDeleting] = useState(false)

  const handleRefresh = () => {
    setRefresh((pre) => !pre)
  }

  const handleSetPerPage = (obj) => {
    setMeta((pre) => ({ ...pre, perPage: obj.value }))
    handleRefresh()
  }

  const debounceFn = (callback, delay) => {
    clearTimeout(timeout)
    timeout = setTimeout(callback, delay)
  }

  const handleSetSearchQuery = (value) => {
    setMeta((pre) => ({ ...pre, search: value }))
    debounceFn(handleRefresh, DEBOUNCE_DELAY)
  }

  const handlePageChange = (value) => {
    setMeta((pre) => ({ ...pre, page: value }))
    handleRefresh()
  }

  const handleCloseModal = () => {
    setTeamModalVisible(false)
    setSelectedTeam()
  }

  const handleOpenModal = () => {
    setTeamModalVisible(true)
  }

  const fetchTeams = async () => {
    const result = await getTeams(meta.page, meta.perPage, meta.search)
    if (result?.LastPage && result?.Total) {
      const resultMeta = result
      setMeta((pre) => ({
        ...pre,
        totalCount: resultMeta.Total,
        totalPages: resultMeta.LastPage,
      }))
    }
    if (result?.teams) {
      setTeamsList(result.teams)
    }
    setLoading(false)
  }

  const handleCreateTeam = async (values) => {
    const updatedValues = { ...values, status: 'pending' }
    const result = await createTeam(updatedValues)
    console.log(result)
    if (result?.message === 'Team created successfully') {
      toast(
        <CustomToast
          variant={alertTypes.SUCCESS}
          message={result?.statusText || 'Team Created Successfully!'}
        />
      )
      handleRefresh()
      handleCloseModal()
    } else {
      toast(
        <CustomToast
          variant={alertTypes.DANGER}
          message={result?.response?.data?.error}
        />
      )
    }
  }

  const handleUpdateTeam = async (payload) => {
    /* eslint no-underscore-dangle: 0 */
    const id = payload._id
    const updatedValues = { ...payload, status: 'pending' }
    const result = await updateTeam(updatedValues, id)
    if (result?.status === 200) {
      toast(
        <CustomToast
          variant={alertTypes.SUCCESS}
          message={result?.statusText || 'Team Updated Successfully!'}
        />
      )
      handleCloseModal()
      handleRefresh()
    } else {
      toast(
        <CustomToast
          variant={alertTypes.DANGER}
          message={result?.response?.data?.error}
        />
      )
    }
  }

  const handleCloseTeamConfirmationModal = () => {
    setTeamConfirmationModalVisible(false)
    setSelectedTeam()
    setIsDeleting(false)
  }

  const handleOpenTeamConfirmationModal = () => {
    setTeamConfirmationModalVisible(true)
  }

  const handleDeleteTeam = async () => {
    const result = await deleteTeam(selectedTeam._id)
    if (result?.message === 'Team deleted successfully') {
      toast(
        <CustomToast
          variant={alertTypes.SUCCESS}
          message={result?.statusText || 'Team Deleted Successfully!'}
        />
      )
      handleRefresh()
      handleCloseTeamConfirmationModal()
    } else {
      toast(
        <CustomToast
          variant={alertTypes.DANGER}
          message={result?.response?.data?.error}
        />
      )
    }
  }

  useEffect(() => {
    fetchTeams()
  }, [refresh])

  return (
    <div className='user-main'>
      <div className='container-fluid'>
        <TableWrapper
          setPerPage={handleSetPerPage}
          setSearchQuery={handleSetSearchQuery}
          searchValue={meta.search}
          totalListCount={meta.totalCount}
          pageSize={meta.perPage}
          currentPage={meta.page}
          onPageChange={handlePageChange}
          actionButtons={[
            ...getActionButtonProps('Add Team', () => {
              handleOpenModal()
            }),
          ]}
        >
          {loading ? (
            <p style={{ textAlign: 'center' }}>Loading</p>
          ) : (
            <table className='table table-main'>
              <thead>
                <tr>
                  <th scope='col'>
                    <div className='header-text-otr'>
                      <p
                        className='table-name heading-xsb'
                        aria-label='Team index Column'
                      >
                        #
                      </p>
                    </div>
                  </th>
                  <th scope='col'>
                    <div className='header-text-otr'>
                      <p
                        className='table-name heading-xsb'
                        aria-label='Team Name Column'
                      >
                        Team Name
                      </p>
                    </div>
                  </th>
                  <th scope='col'>
                    <div className='header-text-otr'>
                      <p
                        className='table-name heading-xsb'
                        aria-label='Team Description Column'
                      >
                        Objective
                      </p>
                    </div>
                  </th>
                  <th scope='col'>
                    <div className='header-text-otr'>
                      <p
                        className='table-name heading-xsb'
                        aria-label='Creation Date Column'
                      >
                        Team Leader
                      </p>
                    </div>
                  </th>
                  <th scope='col'>
                    <div className='header-text-otr'>
                      <p
                        className='table-name heading-xsb'
                        aria-label='Status Column'
                      >
                        Facilitator
                      </p>
                    </div>
                  </th>
                  <th scope='col' className='action-column'>
                    <div className='header-text-otr'>
                      <p
                        className='table-name heading-xsb'
                        aria-label='Actions Column'
                      >
                        Actions
                      </p>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {/* {teamsList.length === 0 && (
                  <tr>
                    <td className='text-center' colSpan={7}>
                      No teams found.
                    </td>
                  </tr>
                )} */}
                {teamsList?.map((item, index) => (
                  <tr key={item.id}>
                    <th scope='col'>
                      <div className='header-text-otr'>
                        <p
                          className='table-name heading-xsb'
                          aria-label='Team Table Data Column'
                        >
                          {index + 1}
                        </p>
                      </div>
                    </th>
                    <td>
                      <div className='table-text-otr'>
                        <p className='table-text-black' title={item.name}>
                          {item.name ?? 'N/A'}
                        </p>
                      </div>
                    </td>

                    <td>
                      <div className='table-text-otr'>
                        <p
                          className='table-text-black'
                          title={item.description}
                        >
                          {item.objective ?? 'N/A'}
                        </p>
                      </div>
                    </td>

                    <td>
                      <div className='table-text-otr'>
                        <p className='table-text-black' title={item.teamLead}>
                          {item.teamLead?.name ?? 'N/A'}
                        </p>
                      </div>
                    </td>

                    <td>
                      <div className='table-text-otr'>
                        <p className='table-text-black' title={item.status}>
                          {/* {item.facilitator?.name ?? 'N/A'} */}
                          {item.facilitators?.map((fac) => fac.name ?? 'N/A')}
                        </p>
                      </div>
                    </td>

                    <td className='action-column'>
                      <div className='table-icon-otr'>
                        <div
                          className='icon-otr'
                          role='button'
                          tabIndex={0}
                          aria-label='Edit Team'
                        >
                          <PencilSimple
                            className='primary-color'
                            size={18}
                            onClick={() => {
                              setSelectedTeam(item)
                              handleOpenModal()
                            }}
                          />
                        </div>
                        <div
                          className='icon-otr'
                          role='button'
                          tabIndex={0}
                          aria-label='Delete Team'
                        >
                          <Trash
                            className='danger-color'
                            size={18}
                            onClick={() => {
                              setIsDeleting(true)
                              setSelectedTeam(item)
                              handleOpenTeamConfirmationModal()
                            }}
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </TableWrapper>
      </div>
      {isTeamConfirmationModalVisible && (
        <ConfirmationModal
          handleConfirmNotification={isDeleting ? handleDeleteTeam : () => {}}
          handleCloseModal={handleCloseTeamConfirmationModal}
          isDeleting={isDeleting}
          selectedNotification={selectedTeam}
        />
      )}
      {isTeamModalVisible && (
        <TeamModal
          handleCloseModal={handleCloseModal}
          selectedTeam={selectedTeam}
          handleSaveTeam={handleCreateTeam}
          handleUpdateTeam={handleUpdateTeam}
        />
      )}
    </div>
  )
}

export default TeamsListing
